<template>
  <div>
    <label for="tg">Tipo de gobierno</label>
    <b-skeleton-wrapper :loading="tgLoader">
      <template #loading>
        <b-skeleton
          type="button"
          width="100%"
          class="mb-75"
        />
      </template>
      <div class="mb-75">
        <v-select
          id="tg"
          placeholder="Seleccione tipo de gobierno"
          label="nombre"
          :value="tg"
          :options="tiposgob"
          :clearable="false"
          @input="(val) => $emit('tipogob', val)"
        />
      </div>
    </b-skeleton-wrapper>
  </div>
</template>
<script>
import {
  BSkeletonWrapper,
  BSkeleton,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import { ref, onMounted } from '@vue/composition-api'
import { getData } from '@core/utils/http/general'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    vSelect,
    BSkeletonWrapper,
    BSkeleton,
  },
  props: {
    tg: {
      type: [Object, null],
      default: null,
    },
  },
  setup(_, { emit }) {
    const tiposgob = ref([])
    const toast = useToast()
    const tgLoader = ref(false)
    const loadTiposGob = () => {
      tgLoader.value = true
      getData({ action: 34 }, 'wspublico')
        .then(response => {
          tgLoader.value = false
          if (response.status === 200) {
            tiposgob.value = response.data.data || []
            emit('catalogotiposgob', tiposgob.value)
          } else {
            toast({
              component: ToastificationContent,
              props: {
                title: 'Error cargando tipos de gobierno',
                text: response.data.message,
                icon: 'AlertCircleIcon',
                variant: 'danger',
              },
            },
            { timeout: 10000 })
          }
        }, error => {
          tgLoader.value = false
          toast({
            component: ToastificationContent,
            props: {
              title: 'Error cargando tipos de gobierno',
              text: error,
              icon: 'AlertCircleIcon',
              variant: 'danger',
            },
          },
          { timeout: 10000 })
        })
    }
    onMounted(() => {
      loadTiposGob()
    })
    return {
      tiposgob,
      tgLoader,
    }
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
